/**
 * @file UsersReportParameters.js
 * @description Users report parameter controls used by GenerateReportPage.
 */

import { SearchableDropdown } from '../helpers/SearchableDropdown';
import { getText } from '../../i18n';

function getSavedOptions(options, selectedIds) {
    const selectedIdSet = new Set((selectedIds || []).map(String));
    return (options || []).filter(option =>
        selectedIdSet.has(String(option.id)),
    );
}

function UsersReportParameters({
    isReadOnlyMode,
    usersParameterOptions,
    usersParameters,
    handleUsersParameterChange,
}) {
    return (
        <div
            style={{
                width: '100%',
                margin: '0 auto',
                display: 'grid',
                gap: '40px',
            }}
        >
            <div>
                <div
                    className="file-form-label"
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_1ef9d5884d25')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_80bbd0a8e7e7')}
                    options={usersParameterOptions.userTypes}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handleUsersParameterChange('userTypes', selectedOptions)
                    }
                    savedOptions={getSavedOptions(
                        usersParameterOptions.userTypes,
                        usersParameters.userTypes,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
            <div>
                <div
                    className="file-form-label"
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_a3c686e711e4')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_4d18568c50da')}
                    options={usersParameterOptions.categories}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handleUsersParameterChange(
                            'categories',
                            selectedOptions,
                        )
                    }
                    savedOptions={getSavedOptions(
                        usersParameterOptions.categories,
                        usersParameters.categories,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
            <div>
                <div
                    className="file-form-label"
                    style={
                        isReadOnlyMode
                            ? { color: 'var(--iNGAGED-Neutral-Color2)' }
                            : { marginBottom: '11px' }
                    }
                >
                    {getText('msg_fefb5bccdde2')}
                </div>
                <SearchableDropdown
                    placeholderLabel={getText('msg_bbef01c8bd3a')}
                    options={usersParameterOptions.userStatuses}
                    optionIDField="id"
                    savedOptionIDField="id"
                    updateOptions={selectedOptions =>
                        handleUsersParameterChange(
                            'userStatuses',
                            selectedOptions,
                        )
                    }
                    savedOptions={getSavedOptions(
                        usersParameterOptions.userStatuses,
                        usersParameters.userStatuses,
                    )}
                    showTags
                    readOnly={isReadOnlyMode}
                    selectAll={true}
                />
            </div>
        </div>
    );
}

export default UsersReportParameters;
